import { render, staticRenderFns } from "./safetyGearStatus.vue?vue&type=template&id=c56bdc48"
import script from "./safetyGearStatus.vue?vue&type=script&lang=js"
export * from "./safetyGearStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c56bdc48')) {
      api.createRecord('c56bdc48', component.options)
    } else {
      api.reload('c56bdc48', component.options)
    }
    module.hot.accept("./safetyGearStatus.vue?vue&type=template&id=c56bdc48", function () {
      api.rerender('c56bdc48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/sas/safetyGearStatus.vue"
export default component.exports